<template>
  <div>
    <el-alert type="info" :closable="false" show-icon class="u-mb-10">
      <div slot="title">Conversas do WhatsApp</div>
      <div class="obs">
        Atendimentos feitos pelo <b>atendente do WhatsApp</b>. Estas conversas ficam
        <b>fora</b> das métricas do Painel de Atendimentos (AV 8 e AV 2), que medem o
        assistente virtual — são motores diferentes, e misturá-los faria aqueles números
        deixarem de significar o que declaram.
      </div>
    </el-alert>

    <el-form :inline="true" size="small" class="u-mb-10">
      <el-form-item label="De">
        <el-date-picker v-model="de" type="date" value-format="yyyy-MM-dd" @change="carregar"></el-date-picker>
      </el-form-item>
      <el-form-item label="Até">
        <el-date-picker v-model="ate" type="date" value-format="yyyy-MM-dd" @change="carregar"></el-date-picker>
      </el-form-item>
      <el-form-item label="Telefone">
        <el-input v-model="telefone" clearable placeholder="últimos dígitos" style="width:160px"
                  @keyup.enter.native="carregar" @clear="carregar"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="carregar">Buscar</el-button>
      </el-form-item>
    </el-form>

    <div v-if="carregando" class="estado" data-test="carregando"><i class="el-icon-loading"></i> carregando…</div>
    <el-alert v-else-if="erro" type="error" :closable="false" show-icon data-test="erro" :title="erro"></el-alert>

    <template v-else>
      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">Conversas</div>
          <div class="val" data-test="total-conversas">{{ resumo.conversas }}</div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">Turnos</div>
          <div class="val" data-test="total-turnos">{{ resumo.turnos }}</div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">Avaliação média</div>
          <div class="val" data-test="media-avaliacao">
            {{ (resumo.avaliacao && resumo.avaliacao.media !== null) ? resumo.avaliacao.media : '—' }}
          </div>
          <div class="obs">{{ (resumo.avaliacao && resumo.avaliacao.respondidas) || 0 }} de {{ resumo.conversas }} avaliaram</div>
        </div></el-col>
        <el-col :xs="24" :sm="6"><div class="cartao">
          <div class="rot">Última mensagem</div>
          <div class="val pequeno" data-test="ultima">{{ resumo.ultima_em || '—' }}</div>
        </div></el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :xs="24" :md="10">
          <el-table :data="itens" size="small" border highlight-current-row empty-text="nenhuma conversa no período"
                    @current-change="abrir" data-test="lista">
            <el-table-column prop="telefone_mascarado" label="Contato" width="140"></el-table-column>
            <el-table-column prop="turnos" label="Turnos" width="70" align="center"></el-table-column>
            <el-table-column prop="satisfacao" label="Nota" width="70" align="center">
              <template slot-scope="s">
                <span v-if="s.row.satisfacao === null" class="obs">—</span>
                <span v-else :class="['nota', s.row.satisfacao >= 4 ? 'boa' : (s.row.satisfacao >= 3 ? 'media' : 'ruim')]">
                  {{ s.row.satisfacao }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="ultima_em" label="Última" :formatter="fmtData"></el-table-column>
          </el-table>

          <el-pagination v-if="total > porPagina" class="u-mt-10" layout="prev, pager, next"
                         :total="total" :page-size="porPagina" :current-page.sync="pagina"
                         @current-change="carregar"></el-pagination>
        </el-col>

        <el-col :xs="24" :md="14">
          <div v-if="!conversa" class="vazio" data-test="sem-selecao">
            Selecione uma conversa à esquerda para ver as mensagens.
          </div>

          <div v-else class="conversa" data-test="conversa">
            <div class="cabecalho">
              <b>{{ conversa.telefone_mascarado }}</b>
              <span class="obs">
                {{ conversa.turnos }} turno(s) · início {{ conversa.iniciada_em }}
                <template v-if="conversa.satisfacao !== null && conversa.satisfacao !== undefined">
                  · avaliação <b>{{ conversa.satisfacao }}/5</b>
                </template>
              </span>
            </div>

            <div class="balcao">
              <div v-for="m in mensagens" :key="m.id" :class="['balao', m.origem]">
                <div class="texto">{{ m.conteudo }}</div>
                <div class="rodape">
                  {{ fmtHora(m.created_at) }}
                  <span v-if="m.meta && m.meta.intencao" class="trilha">
                    · {{ m.meta.intencao }}<span v-if="m.meta.resultado">/{{ m.meta.resultado }}</span>
                    <span v-if="m.meta.origem_dado"> · dado: {{ m.meta.origem_dado }}</span>
                    <span v-if="m.meta.duracao_ms"> · {{ m.meta.duracao_ms }}ms</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
/**
 * FASE 3 — leitura das conversas espelhadas do WhatsApp.
 *
 * SOMENTE LEITURA. Não há como responder por aqui — responder exigiria o caminho de volta
 * da API para o bot, que é decisão à parte (ver specs/FASE_2, §6 do contrato).
 *
 * O telefone chega MASCARADO do backend; esta tela nunca tem o número em claro.
 */
export default {
  data () {
    return {
      de: null, ate: null, telefone: '',
      carregando: false, erro: '',
      resumo: { conversas: 0, turnos: 0, ultima_em: null },
      itens: [], total: 0, pagina: 1, porPagina: 20,
      conversa: null, mensagens: []
    }
  },

  created () { this.carregar() },

  methods: {
    carregar () {
      this.carregando = true
      this.erro = ''

      const p = { de: this.de, ate: this.ate, telefone: this.telefone, por_pagina: this.porPagina, page: this.pagina }

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/whatsapp-admin/conversas`,
        Object.assign({ params: p }, this.$store.getters.getHeaderAuth))
        .then(r => {
          this.resumo = r.data.resumo || this.resumo
          this.itens = (r.data.itens && r.data.itens.data) || []
          this.total = (r.data.itens && r.data.itens.total) || 0
        })
        .catch(() => { this.erro = 'Não foi possível carregar as conversas.' })
        .finally(() => { this.carregando = false })
    },

    abrir (linha) {
      if (!linha) return

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/whatsapp-admin/conversas/${linha.id}`,
        this.$store.getters.getHeaderAuth)
        .then(r => {
          this.conversa = r.data.conversa
          this.mensagens = r.data.mensagens || []
        })
        .catch(() => { this.erro = 'Não foi possível abrir a conversa.' })
    },

    fmtData (linha, coluna, valor) { return valor ? String(valor).replace('T', ' ').substring(0, 16) : '—' },
    fmtHora (v) { return v ? String(v).replace('T', ' ').substring(11, 16) : '' }
  }
}
</script>

<style scoped>
.cartao { background:#fff; border:1px solid #ebeef5; border-radius:4px; padding:10px 12px; margin-bottom:10px; }
.cartao .rot { font-size:12px; color:#909399; }
.cartao .val { font-size:26px; font-weight:600; color:#303133; }
.cartao .val.pequeno { font-size:15px; }
.obs { font-size:12px; color:#909399; }
.estado { padding:20px; color:#909399; }
.vazio { padding:40px 20px; text-align:center; color:#909399; border:1px dashed #dcdfe6; border-radius:4px; }
.conversa { border:1px solid #ebeef5; border-radius:4px; background:#fff; }
.cabecalho { padding:10px 12px; border-bottom:1px solid #ebeef5; display:flex; justify-content:space-between; align-items:baseline; }
.balcao { padding:12px; max-height:480px; overflow-y:auto; background:#f7f8fa; }
.balao { max-width:80%; margin-bottom:10px; padding:8px 10px; border-radius:8px; }
.balao.cidadao { background:#fff; border:1px solid #ebeef5; }
.balao.atendente { background:#e7f4e4; margin-left:auto; }
.balao .texto { white-space:pre-wrap; word-break:break-word; font-size:13px; color:#303133; }
.balao .rodape { font-size:11px; color:#909399; margin-top:4px; }
.trilha { color:#b0b3b8; }
.nota { display:inline-block; min-width:22px; padding:1px 6px; border-radius:10px; font-weight:600; font-size:12px; color:#fff; }
.nota.boa { background:#67c23a; }
.nota.media { background:#e6a23c; }
.nota.ruim { background:#f56c6c; }
</style>
